import { UserRewardRequestInfoDTO } from '@/models';
import { axiosBase } from '@/services/axios-base';

export const fetchCurrentUserRewardRequestInfo = (): Promise<{ data: UserRewardRequestInfoDTO }> => {
  return axiosBase.get('/api/userRewardRequestInfo');
};

export const updateCurrentUserRewardRequestInfo = (
  userRewardRequestInfo: UserRewardRequestInfoDTO
): Promise<{ data: UserRewardRequestInfoDTO }> => {
  return axiosBase.post('/api/userRewardRequestInfo', userRewardRequestInfo);
};
